import React from 'react';
import { ErrorMessage } from 'formik';
import { CInvalidFeedback } from '@coreui/react';

const FormFieldErrorMessage = ({ name }) => {
  return <ErrorMessage name={name} component={CInvalidFeedback} />;
};

export default FormFieldErrorMessage;
